// GPLv3, Copyright (C) 2017, theBlock, https://theblock.io
// @flow

export default {
  location: {
    text: 'I want to {{body}} {{extra}}',
    options: {
      listAccounts: 'view my accounts',
      importAccount: 'add an account',
      send: 'send a transaction',
      settings: 'settings'
    }
  }
};



// WEBPACK FOOTER //
// ./packages/page-index/i18n/en/navigation.js